<template>
  <el-card class="point-control" shadow="never" :body-style="{ padding: 0 }">
    <div slot="header" class="clearfix">
      <span style="font-size: 16px"
        >轨迹信息
        <el-tooltip
          class="item"
          effect="dark"
          content="颜色设置"
          placement="top"
        >
          <i class="el-icon-set-up setcolor" @click="openPalette"></i>
        </el-tooltip>
      </span>
      <el-button
        style="float: right; padding: 3px 0"
        type="text"
        class="danger-button"
        :disabled="!selections.length"
        @click="clearSelectTrajectories"
      >
        清除并添加 {{ selections.length ? `(${selections.length})` : '' }}
      </el-button>
    </div>
    <el-table
      ref="table"
      max-height="400"
      :data="data"
      :row-class-name="handleClassName"
      :row-style="handleStyle"
      row-key="key"
      @selection-change="handleSelectionChange"
      @row-click="onrowclick"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="日期" prop="key">
        <template slot-scope="scope">
          {{ scope.row.key }}

          <i
            v-if="scope.row.outliers.length"
            class="el-icon-warning"
            stype="color: #e6a23c"
          />
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <template slot-scope="scope">
          <div>
            <span v-if="scope.row.added"> 待添加 </span>
            <span
              v-else
              :class="{ 'is-invalid': isinvalidPoint(scope.row.trajectories) }"
            >
              {{ scope.row.trajectories.length }}
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="clearTrajectories([scope.row.key])">
            {{ scope.row.added ? '添加' : '清除并添加' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="palette" width="40%" append-to-body>
      <palette ref="palette" />
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="palette = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveColor"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import Palette from './Palette.vue'

export default {
  components: {
    Palette,
  },
  props: {
    voyageinfo: {
      type: Object,
      default: () => ({}),
    },

    groups: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selections: [],

      palette: false,
    }
  },

  computed: {
    data() {
      const chunks = this.voyageinfo.chunks || [],
        newChunks = []

      const start = this.voyageinfo.btime,
        end = this.voyageinfo.etime

      if (start && end) {
        let btm = dayjs(start, 'YYYY-MM-DD'),
          etm = dayjs(end, 'YYYY-MM-DD')
        while (btm.isBefore(etm)) {
          let k = btm.format('YYYY-MM-DD')
          const chunk = chunks.find(chunk => chunk.key === k) || {
            key: k,
            trajectories: [],
            outliers: [],
            added: true,
          }
          newChunks.push(chunk)

          btm = btm.add(1, 'd')
        }

        return newChunks
      }

      return []
    },

    maptheme() {
      return this.$store.state.app.maptheme || []
    },
  },

  watch: {
    data() {
      this.$nextTick(() => {
        const data = this.data || []

        data.forEach(it => {
          if (!it.added) {
            this.$refs.table.toggleRowSelection(it, true)
          }
        })
      })
    },
  },

  methods: {
    handleSelectionChange(selection) {
      this.$emit('selection', (this.selections = selection))
    },

    isinvalidPoint(points) {
      return points.length === 1 && points[0].invalid
    },

    clearTrajectories(keys) {
      this.$emit('clearvoyage', keys)
    },

    clearSelectTrajectories() {
      if (this.selections.length) {
        this.$confirm('确定清除当前选择轨迹？')
          .then(() => this.clearTrajectories(this.selections.map(k => k.key)))
          .catch(() => null)
      }
    },

    handleClassName(scope) {
      const row = scope.row,
        maptheme = this.maptheme
      const group = this.groups.find(group =>
        (group.keys || []).includes(row.key)
      )

      if (
        group &&
        typeof group.index === 'number' &&
        group.index < maptheme.length
      ) {
        return 'cancel-hover'
      }
    },

    handleStyle(scope) {
      const row = scope.row,
        maptheme = this.maptheme
      const group = this.groups.find(group =>
        (group.keys || []).includes(row.key)
      )

      if (
        group &&
        typeof group.index === 'number' &&
        group.index < maptheme.length
      ) {
        return {
          'background-color': maptheme[group.index].color1,
          color: maptheme[group.index].color2,
        }
      }
    },

    onrowclick(row) {
      if (this.selections.indexOf(row) !== -1) {
        if (row.trajectories.length > 1) {
          this.$emit('row-click', row)
        }
      }
    },

    openPalette() {
      this.palette = true

      this.$nextTick(() => {
        const palette = this.$refs.palette
        if (palette) {
          palette.refresh()
        }
      })
    },

    saveColor() {
      const palette = this.$refs.palette

      if (palette) {
        palette.saveColor()
      }

      this.palette = false
    },
  },
}
</script>

<style lang="scss" scoped>
.point-control {
  .danger-button {
    &:not(.is-disabled) {
      color: #f56c6c;
    }
  }

  .is-invalid {
    color: #f56c6c;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }

  .setcolor {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }

  border: none;
}
</style>

<style lang="scss">
.point-control {
  .el-table__row {
    transition: background-color 0.5s;

    &.cancel-hover {
      &:hover {
        & > td.el-table__cell {
          background: none;
        }
      }
    }
  }
}
</style>
